"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.postProseGeneratorCallbackParams = exports.postProseGeneratorCallbackBody = exports.post = exports.get = exports.getList = void 0;
const validation_1 = __importDefault(require("../../../../../validation"));
const getListParamsRules = {
    id: validation_1.default.rules.string().required().label('Organization ID'),
    productId: validation_1.default.rules.string().required().label('Product ID'),
};
const getListParams = {
    rules: getListParamsRules,
    schema: validation_1.default.schema(getListParamsRules),
};
const getListQueryRules = {
    retryIfIncomplete: validation_1.default
        .rules
        .string()
        .oneOf([
        'false',
        'true',
    ])
        .optional()
        .label('Retry if incomplete?'),
};
const getListQuery = {
    rules: getListQueryRules,
    schema: validation_1.default.schema(getListQueryRules),
};
exports.getList = {
    params: getListParams,
    query: getListQuery,
};
const getParamRules = {
    id: validation_1.default.rules.string().required().label('Organization ID'),
    productId: validation_1.default.rules.string().required().label('Product ID'),
    snapshotId: validation_1.default.rules.string().required().label('Snapshot ID'),
};
const getParams = {
    rules: getParamRules,
    schema: validation_1.default.schema(getParamRules),
};
exports.get = { params: getParams };
const postParamRules = {
    id: validation_1.default.rules.string().required().label('Organization ID'),
    productId: validation_1.default.rules.string().required().label('Product ID'),
};
const postParams = {
    rules: postParamRules,
    schema: validation_1.default.schema(postParamRules),
};
exports.post = { params: postParams };
const postProseGeneratorCallbackBodyRules = {
    sections: validation_1.default.rules.array().of(validation_1.default.rules.object({
        body: validation_1.default.rules.string().label('Body'),
        title: validation_1.default.rules.string().label('Title'),
    })),
};
exports.postProseGeneratorCallbackBody = {
    rules: postProseGeneratorCallbackBodyRules,
    schema: validation_1.default.schema(postProseGeneratorCallbackBodyRules),
};
const postProseGeneratorCallbackParamsRules = {
    id: validation_1.default.rules.string().required().label('Organization ID'),
    productId: validation_1.default.rules.string().required().label('Product ID'),
    productSnapshotId: validation_1.default.rules.string().required().label('ProductSnapshot ID'),
};
exports.postProseGeneratorCallbackParams = {
    rules: postProseGeneratorCallbackParamsRules,
    schema: validation_1.default.schema(postProseGeneratorCallbackParamsRules),
};
